import type { PaginationQuery } from '../../../types/pagination';
import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type { CreateAssignmentRequest, CreateAssignmentResponse, GradeAssignmentSubmissionRequest, ListAssignmentSubmissionsResponse, ListAssignmentsResponse, SubmitAssignmentRequest, Uuid } from '../types';

export function bindHomework(client: ApiClient) {
  return {
async listAssignments(classId: string, params?: PaginationQuery) {
    const qs = new URLSearchParams({ class_id: classId });
    appendPaginationQuery(qs, params);
    return client.request<ListAssignmentsResponse>(`/assignments?${qs.toString()}`);
  },

async createAssignment(body: CreateAssignmentRequest) {
    return client.request<CreateAssignmentResponse>('/assignments', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listAssignmentSubmissions(assignmentId: string, params?: PaginationQuery & { student_id?: string }) {
    const qs = new URLSearchParams({ assignment_id: assignmentId });
    appendPaginationQuery(qs, params);
    if (params?.student_id) qs.set('student_id', params.student_id);
    return client.request<ListAssignmentSubmissionsResponse>(`/assignments/submissions?${qs}`);
  },

async submitAssignment(body: SubmitAssignmentRequest) {
    return client.request<{ submission_id: Uuid }>('/assignments/submissions', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async gradeAssignmentSubmission(body: GradeAssignmentSubmissionRequest) {
    return client.request<void>('/assignments/submissions/grade', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }
  };
}
